@if (showLabels()) {
  <div>{{ 'LIST.LABELS' | translate }}</div>
  @if (currentId) {
    <mat-select [(ngModel)]="selectedLabel" (ngModelChange)="setStatementLabel($event)" id="{{currentId}}">
      <mat-option class="label_none mat-option">NONE</mat-option>
      @for (label of labelList; track label; let i = $index) {
        <mat-option [value]="label" class="{{'label_'+i}} mat-option">
          {{label.name}}
        </mat-option>
      }
    </mat-select>
  }
  @if (!currentId) {
    <mat-select [(ngModel)]="selectedLabel" (ngModelChange)="setStatementLabel($event)">
      <mat-option >NONE</mat-option>
      @for (label of labelList; track label; let i = $index) {
        <mat-option [value]="label">
          {{label.name}}
        </mat-option>
      }
    </mat-select>
  }
}
